import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Path } from "paths";
import { ReservationOverview, ReservationOrders, ReservationBilling, ReservationDetailsHeader } from "modules";
import { useApi, useMount, useRouter } from "hooks";
import { ModuleWrapper } from "components/fragments";
import { getReservationDetail } from "apis/reservation.api";
import { reservationDetailResponse } from "mappers/reservation.mapper";
import { VenueContext } from "contexts";

const ReservationDetailsPage = () => {
  const { query } = useRouter();
  const { id } = query;
  const { venue } = useContext(VenueContext);

  const {
    request,
    mappedData: data,
    loading,
    error,
  } = useApi({
    api: getReservationDetail,
    mapper: reservationDetailResponse,
    handleOwnError: true,
  });

  useMount(() => {
    request({ posReservationId: id, venueId: venue.venueId });
  });

  return (
    <ModuleWrapper loading={loading} error={error}>
      <ReservationDetailsHeader data={data} id={id} loading={loading} />
      <Switch>
        <Route path={Path.RESERVATION_OVERVIEW}>
          <ReservationOverview data={data} loading={loading} error={error} />
        </Route>
        <Route path={Path.RESERVATION_ORDERS}>
          <ReservationOrders data={data} loading={loading} error={error} />
        </Route>
        <Route path={Path.RESERVATION_BILLING}>
          <ReservationBilling data={data} loading={loading} error={error} />
        </Route>
        <Redirect to={Path.RESERVATION_OVERVIEW_NAV(id)} />
      </Switch>
    </ModuleWrapper>
  );
};

export default ReservationDetailsPage;
